import React from 'react';
import { ScreenContainer, ContentFrame } from '@pinwheel/origami';
import { TemplateContinue } from '../../components/TemplateContinue';
import { useOpts } from '../../context';
import SuccessAnimation from '../../components/SuccessAnimation';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import ModalHeader from '../../components/ModalHeader';
var DDSCardSuccess = function () {
    var exit = useOpts().exit;
    var getLocalizedString = useGetLocalizedString();
    return (React.createElement(ScreenContainer, { "data-testid": "DDSCardSuccess" },
        React.createElement(ModalHeader, { hideBackButton: true, hideExitButton: true }),
        React.createElement(ContentFrame, null,
            React.createElement(TemplateContinue, { Image: SuccessAnimation, title: getLocalizedString('YOUR_DIRECT_DEPOSIT_AND_PAYOUT_CARD'), subtitle: getLocalizedString('YOUR_CHANGES_SHOULD'), buttonLabel: getLocalizedString('CLOSE'), buttonEventId: "Success-exit", onContinue: exit }))));
};
export default DDSCardSuccess;
